module.exports = __webpack_public_path__ + "static/img/13.4a2dd7c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/1/eng/13.png
// module id = WUAx
// module chunks = 0